import * as React from 'react'

export interface IProps {}
export const RefetchingSpinner: React.FCC<IProps> = () => (
  <div className="absolute l-0 r-0 t-0 h-[1px] animate-pulse w-full opacity-5 bg-accent" />
)

RefetchingSpinner.displayName = 'RefetchingSpinner'
